/* eslint-disable no-console */
type LogLevel = 'silent' | 'error' | 'warn' | 'info' | 'debug';

class Logger {
  private level: LogLevel = 'info';

  constructor() {
    // 允许通过 localStorage.LOG_LEVEL 覆盖日志级别
    try {
      const lvl = (localStorage.getItem('LOG_LEVEL') as LogLevel) || undefined;
      if (lvl) this.setLevel(lvl);
      // 默认等级：生产环境降噪为 'warn'，开发为 'info'
      if (!lvl) this.level = process.env.NODE_ENV === 'production' ? 'warn' : 'info';
    } catch {}
  }

  setLevel(level: LogLevel) {
    this.level = level;
  }

  private shouldLog(target: LogLevel): boolean {
    const order: LogLevel[] = ['silent', 'error', 'warn', 'info', 'debug'];
    return order.indexOf(target) <= order.indexOf(this.level);
  }

  debug(...args: any[]) {
    if (process.env.NODE_ENV === 'development') {
      console.debug(...args);
    }
  }

  info(...args: any[]) {
    if (process.env.NODE_ENV === 'development') {
      console.info(...args);
    }
  }

  warn(...args: any[]) {
    if (this.shouldLog('warn')) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  }

  error(...args: any[]) {
    if (this.shouldLog('error')) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
  }
}

export default new Logger();
